/** @deprecated Use BusinessFunctionsScreen. Kept for deep links. */
import { DeprecatedSettingsRedirectScreen } from './DeprecatedSettingsRedirectScreen';

export const AddFeaturesScreen = () => (
  <DeprecatedSettingsRedirectScreen target="BusinessFunctions" />
);
